import { DispenserEvent } from '@/features/dispensers/services/schemas.ts';
import Stack from '@mui/material/Stack';
import { formatDateTime } from '@/common/utils/formatDateTime.ts';
import { HowLongAgo } from '@/features/dispensers/components/dispenser-detail/subcomponents/how-long-ago/HowLongAgo.tsx';
import Typography from '@mui/material/Typography';

export interface LastEventDisplayProps {
  event: DispenserEvent;
}

export const LastEventDisplay = ({ event }: LastEventDisplayProps) => {
  return (
    <Stack direction="row" gap={2} alignItems="baseline">
      <span>{formatDateTime(event.eventAt, 'dateTimeShort')}</span>
      <Typography variant="inherit" color="textSecondary">
        <HowLongAgo event={event} />
      </Typography>
    </Stack>
  );
};
